@file:OptIn(InternalResourceApi::class)

package gamerlogue.sharedui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gamerlogue.sharedui.generated.resources/"

@delegate:ResourceContentHash(326_844_336)
internal val Res.string.social__like: StringResource by lazy {
      StringResource("string:social__like", "social__like", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36201, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33821, 28),
      ))
    }

@delegate:ResourceContentHash(1_522_720_148)
internal val Res.string.social__no_users: StringResource by lazy {
      StringResource("string:social__no_users", "social__no_users", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36234, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33850, 44),
      ))
    }

@delegate:ResourceContentHash(403_037_868)
internal val Res.string.social__search_hint: StringResource by lazy {
      StringResource("string:social__search_hint", "social__search_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36291, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33895, 63),
      ))
    }

@delegate:ResourceContentHash(-5_497_295)
internal val Res.string.social__spoiler_reveal: StringResource by lazy {
      StringResource("string:social__spoiler_reveal", "social__spoiler_reveal", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36355, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33959, 58),
      ))
    }

@delegate:ResourceContentHash(1_307_023_513)
internal val Res.string.stats__all_time: StringResource by lazy {
      StringResource("string:stats__all_time", "stats__all_time", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36422, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34018, 35),
      ))
    }

@delegate:ResourceContentHash(1_847_437_334)
internal val Res.string.stats__average_rating: StringResource by lazy {
      StringResource("string:stats__average_rating", "stats__average_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36454, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34054, 49),
      ))
    }

@delegate:ResourceContentHash(1_917_863_195)
internal val Res.string.stats__completed: StringResource by lazy {
      StringResource("string:stats__completed", "stats__completed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36561, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34161, 36),
      ))
    }

@delegate:ResourceContentHash(1_739_699_367)
internal val Res.string.stats__completed_by_year: StringResource by lazy {
      StringResource("string:stats__completed_by_year", "stats__completed_by_year", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36500, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34104, 56),
      ))
    }

@delegate:ResourceContentHash(-759_985_159)
internal val Res.string.stats__hours: StringResource by lazy {
      StringResource("string:stats__hours", "stats__hours", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36602, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34198, 36),
      ))
    }

@delegate:ResourceContentHash(1_488_743_632)
internal val Res.string.stats__owned: StringResource by lazy {
      StringResource("string:stats__owned", "stats__owned", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36643, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34235, 28),
      ))
    }

@delegate:ResourceContentHash(-1_263_405_668)
internal val Res.string.stats__platforms: StringResource by lazy {
      StringResource("string:stats__platforms", "stats__platforms", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36766, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34362, 36),
      ))
    }

@delegate:ResourceContentHash(-1_947_682_054)
internal val Res.string.stats__platforms_hint: StringResource by lazy {
      StringResource("string:stats__platforms_hint", "stats__platforms_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36676, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34264, 97),
      ))
    }

@delegate:ResourceContentHash(1_812_560_711)
internal val Res.string.stats__ratings: StringResource by lazy {
      StringResource("string:stats__ratings", "stats__ratings", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36807, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34399, 34),
      ))
    }

@delegate:ResourceContentHash(879_033_611)
internal val Res.string.stats__reviews: StringResource by lazy {
      StringResource("string:stats__reviews", "stats__reviews", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36838, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34434, 34),
      ))
    }

@delegate:ResourceContentHash(76_615_104)
internal val Res.string.theme__4x: StringResource by lazy {
      StringResource("string:theme__4x", "theme__4x", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36877, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34469, 21),
      ))
    }

@delegate:ResourceContentHash(-389_222_356)
internal val Res.string.theme__action: StringResource by lazy {
      StringResource("string:theme__action", "theme__action", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36899, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34491, 29),
      ))
    }

@delegate:ResourceContentHash(1_014_444_480)
internal val Res.string.theme__business: StringResource by lazy {
      StringResource("string:theme__business", "theme__business", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36929, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34521, 35),
      ))
    }

@delegate:ResourceContentHash(-58_131_800)
internal val Res.string.theme__comedy: StringResource by lazy {
      StringResource("string:theme__comedy", "theme__comedy", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36965, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34557, 29),
      ))
    }

@delegate:ResourceContentHash(1_642_180_161)
internal val Res.string.theme__drama: StringResource by lazy {
      StringResource("string:theme__drama", "theme__drama", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 36999, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34587, 28),
      ))
    }

@delegate:ResourceContentHash(-34_032_317)
internal val Res.string.theme__educational: StringResource by lazy {
      StringResource("string:theme__educational", "theme__educational", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37028, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34616, 42),
      ))
    }

@delegate:ResourceContentHash(1_862_598_603)
internal val Res.string.theme__erotic: StringResource by lazy {
      StringResource("string:theme__erotic", "theme__erotic", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37067, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34659, 29),
      ))
    }

@delegate:ResourceContentHash(965_253_536)
internal val Res.string.theme__fantasy: StringResource by lazy {
      StringResource("string:theme__fantasy", "theme__fantasy", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37101, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34689, 34),
      ))
    }

@delegate:ResourceContentHash(1_261_689_525)
internal val Res.string.theme__historical: StringResource by lazy {
      StringResource("string:theme__historical", "theme__historical", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37136, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34724, 41),
      ))
    }

@delegate:ResourceContentHash(1_056_866_240)
internal val Res.string.theme__horror: StringResource by lazy {
      StringResource("string:theme__horror", "theme__horror", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37174, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34766, 29),
      ))
    }

@delegate:ResourceContentHash(-869_330_981)
internal val Res.string.theme__kids: StringResource by lazy {
      StringResource("string:theme__kids", "theme__kids", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37204, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34796, 27),
      ))
    }

@delegate:ResourceContentHash(-1_252_060_488)
internal val Res.string.theme__mystery: StringResource by lazy {
      StringResource("string:theme__mystery", "theme__mystery", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37236, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34824, 34),
      ))
    }

@delegate:ResourceContentHash(-972_105_504)
internal val Res.string.theme__non_fiction: StringResource by lazy {
      StringResource("string:theme__non_fiction", "theme__non_fiction", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37271, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34859, 42),
      ))
    }

@delegate:ResourceContentHash(129_282_112)
internal val Res.string.theme__open_world: StringResource by lazy {
      StringResource("string:theme__open_world", "theme__open_world", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37314, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34902, 41),
      ))
    }

@delegate:ResourceContentHash(-47_733_920)
internal val Res.string.theme__party: StringResource by lazy {
      StringResource("string:theme__party", "theme__party", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37356, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34944, 28),
      ))
    }

@delegate:ResourceContentHash(-704_748_640)
internal val Res.string.theme__romance: StringResource by lazy {
      StringResource("string:theme__romance", "theme__romance", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37385, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34973, 34),
      ))
    }

@delegate:ResourceContentHash(-10_402_784)
internal val Res.string.theme__sandbox: StringResource by lazy {
      StringResource("string:theme__sandbox", "theme__sandbox", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37420, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35008, 34),
      ))
    }

@delegate:ResourceContentHash(-1_784_957_407)
internal val Res.string.theme__science_fiction: StringResource by lazy {
      StringResource("string:theme__science_fiction", "theme__science_fiction", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37455, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35043, 50),
      ))
    }

@delegate:ResourceContentHash(1_640_696_256)
internal val Res.string.theme__stealth: StringResource by lazy {
      StringResource("string:theme__stealth", "theme__stealth", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37502, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35094, 34),
      ))
    }

@delegate:ResourceContentHash(944_793_216)
internal val Res.string.theme__survival: StringResource by lazy {
      StringResource("string:theme__survival", "theme__survival", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37537, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35129, 35),
      ))
    }

@delegate:ResourceContentHash(-1_547_637_600)
internal val Res.string.theme__thriller: StringResource by lazy {
      StringResource("string:theme__thriller", "theme__thriller", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37573, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35165, 35),
      ))
    }

@delegate:ResourceContentHash(1_919_330_001)
internal val Res.string.theme__unknown: StringResource by lazy {
      StringResource("string:theme__unknown", "theme__unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37609, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35201, 34),
      ))
    }

@delegate:ResourceContentHash(-951_166_228)
internal val Res.string.theme__warfare: StringResource by lazy {
      StringResource("string:theme__warfare", "theme__warfare", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37648, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35236, 34),
      ))
    }

@delegate:ResourceContentHash(436_792_118)
internal val Res.string.viewer__copy_link: StringResource by lazy {
      StringResource("string:viewer__copy_link", "viewer__copy_link", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37679, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35271, 37),
      ))
    }

@delegate:ResourceContentHash(999_275_526)
internal val Res.string.viewer__link_copied: StringResource by lazy {
      StringResource("string:viewer__link_copied", "viewer__link_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37721, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35309, 43),
      ))
    }

@delegate:ResourceContentHash(1_135_846_272)
internal val Res.string.viewer__open_external: StringResource by lazy {
      StringResource("string:viewer__open_external", "viewer__open_external", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37765, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35353, 49),
      ))
    }

@delegate:ResourceContentHash(1_144_638_728)
internal val Res.string.viewer__page: StringResource by lazy {
      StringResource("string:viewer__page", "viewer__page", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37819, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35403, 36),
      ))
    }

@delegate:ResourceContentHash(-327_170_375)
internal val Res.string.viewer__save: StringResource by lazy {
      StringResource("string:viewer__save", "viewer__save", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37970, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35538, 36),
      ))
    }

@delegate:ResourceContentHash(-1_149_232_527)
internal val Res.string.viewer__save_failed: StringResource by lazy {
      StringResource("string:viewer__save_failed", "viewer__save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37856, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35440, 59),
      ))
    }

@delegate:ResourceContentHash(863_359_636)
internal val Res.string.viewer__saved: StringResource by lazy {
      StringResource("string:viewer__saved", "viewer__saved", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 37924, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35500, 37),
      ))
    }

@delegate:ResourceContentHash(-365_624_853)
internal val Res.string.viewer__share: StringResource by lazy {
      StringResource("string:viewer__share", "viewer__share", setOf(
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 38011, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35575, 29),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("social__like", Res.string.social__like)
  map.put("social__no_users", Res.string.social__no_users)
  map.put("social__search_hint", Res.string.social__search_hint)
  map.put("social__spoiler_reveal", Res.string.social__spoiler_reveal)
  map.put("stats__all_time", Res.string.stats__all_time)
  map.put("stats__average_rating", Res.string.stats__average_rating)
  map.put("stats__completed", Res.string.stats__completed)
  map.put("stats__completed_by_year", Res.string.stats__completed_by_year)
  map.put("stats__hours", Res.string.stats__hours)
  map.put("stats__owned", Res.string.stats__owned)
  map.put("stats__platforms", Res.string.stats__platforms)
  map.put("stats__platforms_hint", Res.string.stats__platforms_hint)
  map.put("stats__ratings", Res.string.stats__ratings)
  map.put("stats__reviews", Res.string.stats__reviews)
  map.put("theme__4x", Res.string.theme__4x)
  map.put("theme__action", Res.string.theme__action)
  map.put("theme__business", Res.string.theme__business)
  map.put("theme__comedy", Res.string.theme__comedy)
  map.put("theme__drama", Res.string.theme__drama)
  map.put("theme__educational", Res.string.theme__educational)
  map.put("theme__erotic", Res.string.theme__erotic)
  map.put("theme__fantasy", Res.string.theme__fantasy)
  map.put("theme__historical", Res.string.theme__historical)
  map.put("theme__horror", Res.string.theme__horror)
  map.put("theme__kids", Res.string.theme__kids)
  map.put("theme__mystery", Res.string.theme__mystery)
  map.put("theme__non_fiction", Res.string.theme__non_fiction)
  map.put("theme__open_world", Res.string.theme__open_world)
  map.put("theme__party", Res.string.theme__party)
  map.put("theme__romance", Res.string.theme__romance)
  map.put("theme__sandbox", Res.string.theme__sandbox)
  map.put("theme__science_fiction", Res.string.theme__science_fiction)
  map.put("theme__stealth", Res.string.theme__stealth)
  map.put("theme__survival", Res.string.theme__survival)
  map.put("theme__thriller", Res.string.theme__thriller)
  map.put("theme__unknown", Res.string.theme__unknown)
  map.put("theme__warfare", Res.string.theme__warfare)
  map.put("viewer__copy_link", Res.string.viewer__copy_link)
  map.put("viewer__link_copied", Res.string.viewer__link_copied)
  map.put("viewer__open_external", Res.string.viewer__open_external)
  map.put("viewer__page", Res.string.viewer__page)
  map.put("viewer__save", Res.string.viewer__save)
  map.put("viewer__save_failed", Res.string.viewer__save_failed)
  map.put("viewer__saved", Res.string.viewer__saved)
  map.put("viewer__share", Res.string.viewer__share)
}
